import React from "react";
import parse from "html-react-parser";
import Icon from "../../Elements/Icon/Icon.tsx";
import YoutubeHomePromo from "components/Pages/Home/Reusable/YoutubeHomePromo.js";
import Image from "components/Elements/Image/Image.tsx";
import { newLinkUrl } from "./Helpers.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import config from 'config.ts';

const general = `${config.api.resource}/assets/images/notifications/general.png`;
const personal = `${config.api.resource}/assets/images/notifications/personal.png`;
const activity = `${config.api.resource}/assets/images/notifications/activity.png`;

//NotificationType
const NotificationList = ({
  updateNotification,
  displayList,
  setOpenThreeDots,
  openThreeDots,
}) => {
  const { getTextByKey, getLanguage, getBlackFridayTimeCookie } = useContent();
  const { getUserData } = useUser();

  const fixPopUpButtonLink = (str, notification) => {
    let temp = str;
    if (temp) {
      if (getUserData()) {
        if (getUserData().Subscribtion_Expired) {
          temp = temp.replace("#subscriptiontype#", "subscription");
          if (getUserData().Subscription === "JM Business") {
            temp = temp.replace("#subscriptionpackage#", "business");
          } else if (getUserData().Subscription === "JM Pro") {
            temp = temp.replace("#subscriptionpackage#", "pro");
          }
        }

        if (notification !== null || notification !== undefined) {
          if (
            notification.EncryptedMailId !== null ||
            notification.EncryptedMailId !== undefined
          ) {
            if (str.includes("#mailid#")) {
              temp = temp.replace("#mailid#", notification.EncryptedMailId);
            }
          }
        }
      }
    }
    return temp;
  };

  return (
    <div
      className={`notifications-list ${
        getBlackFridayTimeCookie() ? "include-blackfriday-header" : ""
      }`}
    >
      <ul className="list-items-notifications">
        {displayList.map((item, i) => (
          <li
            className={`notification-row ${
              item.UserNotificationClicked ? "displayed" : ""
            } ${item.UserNotificationHidden ? "hidden" : ""}`}
            key={i}
          >
            <div className="notification-div">
              {item.NotificationLinkUrl ? (
                <div className="image-div">
                  <a
                    onClick={() => {
                      updateNotification(item, "click");
                    }}
                    target={item.NotificationLinkTarget}
                    href={fixPopUpButtonLink(
                      newLinkUrl(item, getLanguage()),
                      item
                    )}
                  >
                    {item.UserNotificationImportant && (
                      <span className="is-important">
                        <i className="fas fa-star"></i>
                      </span>
                    )}
                    <Image
                      alt={item.NotificationType.toLowerCase()}
                      title={item.NotificationType.toLowerCase()}
                      className="notif-image"
                      src={
                        item.NotificationType.toLowerCase() === "general"
                          ? general
                          : item.NotificationType.toLowerCase() === "personal"
                          ? personal
                          : activity
                      }
                    />
                  </a>
                </div>
              ) : (
                <div
                  className="image-div"
                  onClick={() => {
                    updateNotification(item, "click");
                  }}
                >
                  {item.UserNotificationImportant && (
                    <span className="is-important">
                      <i className="fas fa-star"></i>
                    </span>
                  )}
                  <Image
                    alt={item.NotificationType.toLowerCase()}
                    title={item.NotificationType.toLowerCase()}
                    className="notif-image"
                    src={
                      item.NotificationType.toLowerCase() === "general"
                        ? general
                        : item.NotificationType.toLowerCase() === "personal"
                        ? personal
                        : activity
                    }
                  />
                </div>
              )}
              {item.NotificationLinkUrl ? (
                <div className="desctription-div">
                  <a
                    onClick={() => {
                      updateNotification(item, "click");
                    }}
                    target={item.NotificationLinkTarget}
                    href={fixPopUpButtonLink(
                      newLinkUrl(item, getLanguage()),
                      item
                    )}
                  >
                    <div className="title-and-text">
                      <span className="title">
                        {parse(item.NotificationTitle)}
                      </span>
                      <span className="text">
                        {parse(item.NotificationText)}
                      </span>
                    </div>
                    <span className="time">{item.DateToDisplay}</span>
                  </a>
                </div>
              ) : (
                <div
                  className="desctription-div"
                  onClick={() => {
                    updateNotification(item, "click");
                  }}
                >
                  <div className="title-and-text">
                    <span className="title">
                      {parse(item.NotificationTitle)}
                    </span>
                    <span className="text">{parse(item.NotificationText)}</span>
                  </div>
                  {item.NotificationVideoLink ? (
                    <YoutubeHomePromo link={item.NotificationVideoLink} />
                  ) : null}
                  <span className="time">{item.DateToDisplay}</span>
                </div>
              )}

              <div
                className="highlight-div"
                onClick={() =>
                  setOpenThreeDots((prev) => (prev === i ? null : i))
                }
              >
                <span className="bullet">
                  <Icon name="dots-vertical" />
                </span>
              </div>
            </div>
            <div
              //ref={ref}
              className={`three-dots ${
                openThreeDots === i ? "open-dots" : "close-dots"
              } `}
            >
              <ul className="actions-list">
                <li>
                  <div className="">
                    <span className="icon-star icon">
                      <i className="fas fa-star"></i>
                    </span>
                    <span
                      onClick={() => updateNotification(item, "important")}
                      className="text"
                    >
                      {item.UserNotificationImportant
                        ? getTextByKey("mark-un-important")
                        : getTextByKey("mark-important")}
                    </span>
                  </div>
                </li>
                <li>
                  <div className="">
                    <span className="icon-hide icon">
                      <i className="fas fa-minus-circle"></i>
                    </span>
                    <span
                      onClick={() => updateNotification(item, "hidden")}
                      className="text"
                    >
                      {getTextByKey("mark-hidden")}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotificationList;
